.reddi-logo{width:122px;height:27px}
/*# sourceMappingURL=reddi-logo.component-QKNCUCTH.css.map */
